// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function ShowAllDataLink(props) {
  let __label = props.label;
  let label = __label !== undefined ? __label : I18n.t("Show all data");
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: label,
        variant: "subtle",
        trailingIcon: "arrow_right",
        href: props.href
      }),
      align: "center"
    }),
    spaceX: "normal",
    spaceTop: "normal"
  });
}

let make = ShowAllDataLink;

export {
  make,
}
/* Box Not a pure module */
